import { render, staticRenderFns } from "./ExaminationSchedulerSubject.vue?vue&type=template&id=82dbec94&"
import script from "./ExaminationSchedulerSubject.vue?vue&type=script&lang=js&"
export * from "./ExaminationSchedulerSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports